import { FeatureIdEnum, FilterIdEnum } from '../../enums';

import { AppRouteConfig } from '../../models';

import { InsightsLanding, Keywords, Now, Origins } from '../../views';

import { ROUTER_CONSTS } from '../router.consts';

const INSIGHTS_PATHS = {
  insights: 'insights',
  now: 'now',
  origins: 'origins',
  keywords: 'keywords'
};

export const INSIGHTS_ROUTES: AppRouteConfig[] = [
  {
    name: ROUTER_CONSTS.routes.insights,
    path: INSIGHTS_PATHS.insights,
    component: InsightsLanding,
    meta: {
      featureId: FeatureIdEnum.INSIGHTS
    }
  }, {
    name: ROUTER_CONSTS.routes.now,
    path: INSIGHTS_PATHS.now,
    component: Now,
    meta: {
      featureId: FeatureIdEnum.NOW,
      filters: () => ({
        regularFiltersEnabled: true,
        config: {
          [FilterIdEnum.REALTIME]: {
            enabled: true,
            mandatory: true,
            intervalsInMinutes: [15, 60, (12 * 60)]
          }
        }
      })
    }
  }, {
    name: ROUTER_CONSTS.routes.origins,
    path: INSIGHTS_PATHS.origins,
    component: Origins,
    meta: {
      featureId: FeatureIdEnum.ORIGINS,
      filters: () => ({
        regularFiltersEnabled: true,
        config: {
          [FilterIdEnum.DATE]: {
            enabled: true,
            mandatory: true
          }
        },
        initiallyHidden: true
      })
    }
  }, {
    name: ROUTER_CONSTS.routes.keywords,
    path: INSIGHTS_PATHS.keywords,
    component: Keywords,
    meta: {
      featureId: FeatureIdEnum.KEYWORDS,
      filters: () => ({
        regularFiltersEnabled: true,
        config: {
          [FilterIdEnum.DATE]: {
            enabled: true,
            mandatory: true
          }
        }
      })
    }
  }
];
